import { testimonials } from '../../data';
import './Testimonials.css';

function Testimonials() {
  const doubled = [...testimonials, ...testimonials];

  return (
    <section className="test-section" id="reviews">
      <span className="sec-pre rv">Client Stories</span>
      <h2 className="sec-h rv">
        Real people. <em>Real results.</em>
      </h2>

      <div className="test-marquee-wrap">
        <div className="test-track">
          {doubled.map((t, i) => (
            <div key={i} className="t-card">
              <div className="t-stars">★★★★★</div>
              <blockquote>"{t.quote}"</blockquote>
              <div className="t-auth">
                <div className="t-av">{t.initials}</div>
                <div>
                  <div className="t-name">{t.name}</div>
                  <div className="t-role">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
